export default function isExpired(date) {
    return date && Date.now() > new Date(date).getTime();
}
